import React, { useEffect, useState } from "react";
import axios from "axios";
//import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import serverConfig from "../config";
import "./Home.css";
import Header from "../Header";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";
//import icon_f from "../img/facebook.png";
//import icon_i from "../img/instagram.png";
//import icon_l from "../img/linkedin.png";
//import icon_f_p from "../img/facebook_post.png";
//import icon_i_p from "../img/instagram_post.png";
//import icon_l_p from "../img/linkedin_post.png";
import UtilsCalendar from "../utils/UtilsCalendar";
import HomeCarousel from "./HomeCarousel";

import icon_l from "../icon/li.png";
import icon_f from "../icon/fb.png";
import icon_i from "../icon/in.png";
import HomeImageCarousel from "./HomeImageCarousel";

function Home() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_home`)
      .then((response) => {
        const data = response.data;
        setContent(data);
      })
      .catch((error) => {
        //alert("ERRORE | get_data_ions");
        //console.log("PAGINA INIZIALE | get_data_ions | error", error);
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  //const [selectedYear, setSelectedYear] = useState(new Date());
  const selectedYear = new Date().getFullYear();
  const [conferences, setConferences] = useState([]);
  const [trainingSchools, setTrainingSchools] = useState([]);
  const year = selectedYear;

  useEffect(() => {
    //const year = selectedYear.getFullYear();

    axios
      .post(`${serverConfig.serverUrl}/get_conferences_year`, {
        year: year,
      })
      .then((response) => {
        const data = response.data;
        setConferences(data[year]);
      })
      .catch((error) => {
        //alert("ERRORE | get_conferences_year");
        toast.error("La risorsa non è al momento disponibile");
        //console.log("PAGINA INIZIALE | get_conferences_year | error", error);
      });
    axios
      .post(`${serverConfig.serverUrl}/get_training_schools`, {
        year: year,
      })
      .then((response) => {
        const data = response.data;
        setTrainingSchools(data[year]);
      })
      .catch((error) => {
        //alert("ERRORE | get_training_schools");
        toast.error("La risorsa non è al momento disponibile");
      });
  }, [selectedYear, year]);

  const contentSpettrometria = (
    <div style={{ height: "100%", overflowY: "auto", color: "#2C2C2C" }}>
      {content && (
        <div
          style={{ padding: "10px", fontSize: "14px" }}
          dangerouslySetInnerHTML={{
            //__html: content && content["3_TEXT"][0]["text"],
            __html:
              content &&
              content["3_TEXT"] &&
              content["3_TEXT"][0] &&
              content["3_TEXT"][0]["text"],
          }}
        />
      )}
    </div>
  );

  const contentSchool = (
    <div>
      <div style={{ height: "50px" }}>
        <h2 style={{ color: "#003366" }}>SCUOLE DI FORMAZIONE {year}</h2>
      </div>
      {trainingSchools && trainingSchools.length > 0 && (
        <HomeCarousel
          slides={trainingSchools}
          url_path={"/img/training_schools/"}
          isSchool={true}
        ></HomeCarousel>
      )}
    </div>
  );

  const contentConferences = (
    <div>
      <div style={{ height: "50px" }}>
        <h2 style={{ color: "#003366" }}>CONGRESSI {year}</h2>
      </div>

      {conferences && conferences.length > 0 && (
        <HomeCarousel
          slides={conferences}
          url_path={"/img/conference/"}
          isSchool={false}
        ></HomeCarousel>
      )}
    </div>
  );

  const contentVideo = (
    <>
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <video
          controls
          style={{
            width: "100%",
            height: "auto",
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        >
          <source
            src={`${serverConfig.serverUrl}/video/home/video_presentazione.mp4`}
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  );

  const styles = {
    contentBox: {
      //boxShadow: "0 0 10px darkblue",
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      textAlign: "center",
      fontSize: "12px",
      height: "410px",
      overflowY: "auto",
      padding: "10px",
    },
    contentBoxDouble: {
      //boxShadow: "0 0 10px darkblue",
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      textAlign: "center",
      fontSize: "12px",
      height: "830px",
      overflowY: "auto",
      padding: "10px",
    },
    contentBoxImg: {
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      textAlign: "center",
      fontSize: "12px",
      height: "410px",
      padding: "10px",
    },
    contentBoxImgCarousel: {
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      textAlign: "center",
      fontSize: "12px",
      height: "410px",
    },
    contentBoxSocial: {
      //boxShadow: "0 0 10px darkblue",
      marginTop: "10px",
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      textAlign: "center",
      fontSize: "12px",
      padding: "10px",
    },
    gridContainer: {
      display: "grid",
      gridTemplateColumns: "1fr 3fr",
      height: "100%",
      gap: "10px",
    },
    sidebar: {
      //boxShadow: "0 0 10px darkblue",
      boxShadow: "0 0 10px #003366",
      backgroundColor: "#F2F4F7",
      borderRadius: "10px",
      padding: "10px",
      overflowY: "auto",
      height: "830px",
    },
    mainContent: {
      display: "grid",
      gridTemplateRows: "auto auto",
      gap: "10px",
      height: "100%",
      alignContent: "start",
    },
    rowContent: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "10px",
    },
  };

  const contentSocial = (
    <>
      <a
        href="https://www.facebook.com/profile.php?id=100008399616995&fref=ts"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_f}
          alt="Facebook"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
      <a
        href="https://www.instagram.com/div_spettrometriadimassa?igshid=YmMyMTA2M2Y%3D"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_i}
          alt="Instagram"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
      <a
        href="https://www.linkedin.com/company/spettrometria-di-massa/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_l}
          alt="LinkedIn"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
    </>
  );


  const imageUrls = [
    'https://picsum.photos/id/1018/800/400',
    'https://picsum.photos/id/1015/800/400',
    'https://picsum.photos/id/1019/800/400'
  ];

  const contentInfo = (
    <div className="row">
      <div className="col-12 col-lg-3" style={{ marginTop: "10px" }}>
        <div style={styles.sidebar}>
          <h3 style={{ textAlign: "center", color: "#003366" }}>
            I NOSTRI EVENTI
          </h3>
          <UtilsCalendar />

          <div style={styles.contentBoxSocial}>
            <h3 style={{ textAlign: "center", color: "#003366" }}>
              SEGUICI SUI NOSTRI SOCIAL
            </h3>
            <div>{contentSocial}</div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-9">
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-12 col-md-6">
            <div style={styles.contentBoxDouble}>{contentSpettrometria}</div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div style={styles.contentBox}>{contentVideo}</div>
            </div>
            <div className="row" style={{ marginTop: "10px" }}>
              <div style={styles.contentBoxImgCarousel}>
                <div style={{fontSize: '25px', textAlign: 'center', alignItems: 'center', paddingTop: '20px', color: '#003366'}}>
                Le immagini degli eventi di spettrometria di massa saranno presto disponibili in questo box.
                {/*}
                <HomeImageCarousel images={imageUrls} />
                */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  /*
  const ImageLayout = (
    <div >
      <div className="row" style={{ alignItems: "center" }}>
        <div className="col-3">
          <img
            src={`${serverConfig.serverUrl}/img/sfondo_home/Originale.png`}
            alt="SOC"
            className="corner-image"
          />
        </div>
        <div className="col-6"></div>
        <div className="col-3">
          <img
            src={`${serverConfig.serverUrl}/img/sfondo_home/imss-logo-400.jpg`}
            alt="imss"
            className="corner-image"
          />
        </div>
      </div>
      <div className="row" style={{ alignItems: "center" }}>
        <div className="col-12">
          <img
            src={`${serverConfig.serverUrl}/img/sfondo_home/sdm.png`}
            alt="Consiglio direttivo sdm"
            className="image-home"
          />
        </div>
      </div>
    </div>
  );
  */

  const ImageLayout = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%", // Assicurati che il genitore abbia altezza fissata
      }}
    >
      <div
        className="row"
        style={{
          alignItems: "center",
          height: "30%",
          alignContent: "center",
        }}
      >
        <div
          className="col-3"
          style={{ height: "100%" }}
        >
          <div style={{ height: "100%" }}>
            <img
              src={`${serverConfig.serverUrl}/img/sfondo_home/Originale.png`}
              alt="SOC"
              className="corner-image"
            />
          </div>
        </div>
        <div className="col-6"></div>
        <div
          className="col-3"
          style={{ height: "100%" }}
        >
          <div style={{ height: "100%" }}>
            <img
              src={`${serverConfig.serverUrl}/img/sfondo_home/imss-logo-400.jpg`}
              alt="imss"
              className="corner-image"
            />
          </div>
        </div>
      </div>
      <div
        className="row"
        style={{
          alignItems: "center",
          height: "70%",
        }}
      >
        <div
          className="col-12"
          style={{  height: "100%" }}
        >
          <img
            src={`${serverConfig.serverUrl}/img/sfondo_home/sdm.png`}
            alt="Consiglio direttivo sdm"
            className="image-home"
          />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div>
        <Toaster />
        {/*}
        <div
          className="row"
          style={{ marginTop: "10px", marginBottom: "10px" }}
        >
          <div className="col-4">{ImageLayout}</div>
          <div className="col-4">
            <div style={styles.contentBox}>{contentConferences}</div>
          </div>
          <div className="col-4">
            <div style={styles.contentBox}>{contentSchool}</div>
          </div>
        </div>
        */}
        <div className="row my-3">
          <div 
          style={styles.contentBoxImg}
          className="col-12 col-lg-4 mb-3">
            {ImageLayout}
          </div>

          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div style={styles.contentBoxImg}>{contentConferences}</div>
          </div>
          <div className="col-12 col-md-6 col-lg-4 mb-3">
            <div style={styles.contentBoxImg}>{contentSchool}</div>
          </div>
        </div>

        <Header />
        <SecondaryMenu />
        {contentInfo}
      </div>
    </>
  );
}

export default Home;
